import React from 'react'
import {Icon} from '@chakra-ui/react'

const HeaderDown = (props) => {
    return (
        <Icon viewBox="0 0 16 16" width="16" height="16" fill="none" {...props} aria-hidden="true">
            <path
                id="arrow"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.46535 5.11326C2.30574 5.30479 2.32191 5.59807 2.50148 5.76832L7.85228 10.8417L13.0162 5.96906C13.1961 5.79927 13.213 5.50603 13.0538 5.31409C12.8946 5.12215 12.6197 5.1042 12.4398 5.27399L7.85367 9.60137L3.07947 5.07473C2.89991 4.90448 2.62496 4.92173 2.46535 5.11326Z"
                stroke="currentColor"
                strokeLinecap="round"
            />
        </Icon>
    )
}

export default HeaderDown
